import React, {
	useEffect,
	useState
} from "react";

import styled from "styled-components";

import {
	collection,
	getDocs
} from "firebase/firestore";

import { db }
	from "../firebase/firebaseConfig";

	import motorPreguntas
	from "../funciones/motorPreguntas";

import toast
	from "react-hot-toast";

const Contenedor = styled.div`
	min-height: 100vh;

	padding: 2rem;

	background:
		radial-gradient(
			circle at top,
			#220d0d 0%,
			#120606 50%,
			#050505 100%
		);

	color: white;
`;

const BossCard = styled.div`
	max-width: 1000px;

	margin: 0 auto;

	background:
		rgba(255,255,255,0.05);

	border:
		2px solid rgba(239,68,68,0.3);

	border-radius: 30px;

	padding: 2rem;
`;

const BossHeader = styled.div`
	text-align: center;

	margin-bottom: 2rem;
`;

const BossName = styled.h1`
	font-size: 3rem;

	color: #ef4444;

	margin-bottom: 1rem;
`;

const HpBar = styled.div`
	width: 100%;
	height: 30px;

	background:
		rgba(255,255,255,0.08);

	border-radius: 999px;

	overflow: hidden;

	margin-bottom: 1rem;
`;

const HpFill = styled.div`
	height: 100%;

	width: ${({ hp }) => hp}%;

	background:
		linear-gradient(
			90deg,
			#ef4444,
			#dc2626
		);

	transition: 0.4s ease;
`;

const Timer = styled.div`
	font-size: 1.4rem;
	font-weight: 800;

	color: #facc15;

	text-align: center;

	margin-bottom: 2rem;
`;

const Pregunta = styled.div`
	font-size: 1.3rem;

	margin-bottom: 2rem;

	text-align: center;
`;

const Opciones = styled.div`
	display: flex;
	flex-direction: column;

	gap: 1rem;
`;

const Opcion = styled.button`
	padding: 1rem;

	border-radius: 18px;

	border:
		1px solid rgba(255,255,255,0.08);

	background:
		rgba(255,255,255,0.05);

	color: white;

	font-size: 1rem;

	cursor: pointer;

	transition: 0.2s ease;

	&:hover {
		transform: translateY(-2px);

		border-color: #ef4444;
	}
`;

const EndScreen = styled.div`
	text-align: center;

	padding: 4rem 2rem;
`;

const EndTitle = styled.h1`
	font-size: 3rem;

	margin-bottom: 1rem;

	color:
		${({ win }) =>
			win
				? "#22c55e"
				: "#ef4444"};
`;

const BossBattle = () => {

	const [preguntas, setPreguntas] =
		useState([]);

	const [preguntaActual,
		setPreguntaActual] =
		useState(null);

	const [bossHp, setBossHp] =
		useState(100);

	const [timer, setTimer] =
		useState(120);

	const [gameOver, setGameOver] =
		useState(false);

	const [victory, setVictory] =
		useState(false);

	// =====================
	// TIMER
	// =====================

	useEffect(() => {

		if (
			gameOver ||
			victory
		) return;

		const interval =
			setInterval(() => {

				setTimer((prev) => {

					if (prev <= 1) {

						setGameOver(true);

						clearInterval(interval);

						return 0;
					}

					return prev - 1;
				});

			}, 1000);

		return () =>
			clearInterval(interval);

	}, [gameOver, victory]);

	// =====================
	// LOAD QUESTIONS
	// =====================

	useEffect(() => {

		const cargar =
			async () => {

			const snap =
				await getDocs(
					collection(
						db,
						"preguntas"
					)
				);

			const data =
				snap.docs.map(
					(doc) =>
						doc.data()
				);

			setPreguntas(data);

			setPreguntaActual(
				motorPreguntas(
					data
				)
			);
		};

		cargar();

	}, []);

	// =====================
	// ANSWER
	// =====================

	const responder =
		(opcion) => {

		if (!preguntaActual)
			return;

		const correcta =
			preguntaActual
				.Respuesta
				?.toLowerCase();

		if (
			opcion.toLowerCase() ===
			correcta
		) {

			const damage =
				10 +
				Math.floor(
					Math.random() * 10
				);

			const newHp =
				bossHp - damage;

			setBossHp(newHp);

			toast.success(
				`⚔️ -${damage} HP`
			);

			if (newHp <= 0) {

				setVictory(true);

				toast.success(
					"🏆 BOSS DERROTADO",
					{
						duration: 6000
					}
				);

				return;
			}

		} else {

			setTimer(
				(prev) =>
					Math.max(
						prev - 5,
						0
					)
			);

			toast.error(
				"💥 El boss te castigó"
			);
		}

		setPreguntaActual(
			motorPreguntas(
				preguntas
			)
		);
	};

	// =====================
	// ENDINGS
	// =====================

	if (victory) {

		return (
			<Contenedor>

				<EndScreen>

					<EndTitle win>

						🏆 VICTORIA

					</EndTitle>

					<div>
						Derrotaste al Boss.
					</div>

				</EndScreen>

			</Contenedor>
		);
	}

	if (gameOver) {

		return (
			<Contenedor>

				<EndScreen>

					<EndTitle>

						💀 DERROTA

					</EndTitle>

					<div>
						El boss sobrevivió.
					</div>

				</EndScreen>

			</Contenedor>
		);
	}

	return (

		<Contenedor>

			<BossCard>

				<BossHeader>

					<BossName>

						👹 Boss de Física

					</BossName>

					<HpBar>

						<HpFill
							hp={bossHp}
						/>

					</HpBar>

					<div>
						HP:
						{" "}
						{bossHp}
						/100
					</div>

				</BossHeader>

				<Timer>

					⏳ {timer}s

				</Timer>

				{preguntaActual && (

					<>

						<Pregunta>

							Pregunta #
							{
								preguntaActual.ID
							}

						</Pregunta>

						<Opciones>

							{
								["a","b","c","d"]
								.map((op) => (

									<Opcion
										key={op}
										onClick={() =>
											responder(op)
										}
									>

										Opción
										{" "}
										{
											op.toUpperCase()
										}

									</Opcion>

								))
							}

						</Opciones>

					</>

				)}

			</BossCard>

		</Contenedor>
	);
};

export default BossBattle;